// extracted by mini-css-extract-plugin
export default {"aboutPage":"AboutPage_aboutPage__juJr-"};